<template>
	<v-avatar v-if="iconUrl" :color="colour" size="20" class="AppBadge">
		<v-img :src="iconUrl" width="13" height="13" />
	</v-avatar>
	<Tag v-else :value="label" />
</template>

<script>
import Tag from '@/components/common/Tag.vue'

// the app's dashboard-card icon, looked up from the acting user's resolved appComponents in
// the store — the ceiling only offers apps the acting user has themselves, so no extra fetch
// is needed. Falls back to the 3-letter Tag badge when no icon is found.
export default {
	name: 'AppBadge',
	components: { Tag },
	props: {
		// { id, title } from the permission ceiling (or an out-of-scope app of the same shape)
		app: Object,
	},
	computed: {
		component() {
			const apps = this.$store.state.loggedInUser?.fields?.applications?.de ?? []
			return apps.find(a => a?.sys?.id === this.app?.id)
		},
		iconUrl() {
			const url = this.component?.fields?.icon?.de?.fields?.file?.de?.url
			if (!url) return undefined
			return url.startsWith('//') ? 'https:' + url : url
		},
		colour() {
			return this.component?.fields?.colour?.de ?? '#868686'
		},
		label() {
			return this.app?.title || this.app?.id || ''
		},
	},
}
</script>

<style scoped>
.AppBadge { margin-right: 5px; }
</style>
